import { render, staticRenderFns } from "./Graphs.vue?vue&type=template&id=72d66873&"
import script from "./Graphs.vue?vue&type=script&lang=ts&"
export * from "./Graphs.vue?vue&type=script&lang=ts&"
import style0 from "./Graphs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports